window.$ = window.jQuery = require('jquery');
require("@fancyapps/fancybox/dist/jquery.fancybox.min");
require("../elements/form");
$(document).ready(function() {
    if ($("#modal-beforeunload").length) {
        $('a[href^="http"][id!="link-beforeunload"][target!="_blank"]').on("click", function(e) {
            e.preventDefault();
            var _href = $(this).attr('href');
            $('a#link-beforeunload').attr('href', _href);
            $('#modal-beforeunload').fancybox({
                touch: false
            }).trigger('click');
            return false;
        });
    }
    $("#link-beforeunload").on('click', function () {
       window.location.href = $(this).attr("href");
    });
    if (statusUrl) {
        var statusInformer = function () {
            $.ajax({
                url     : statusUrl,
                method  : "get",
                dataType: "json",
                success : function (data) {
                    if (data.changed === true || data.waiting_time_is_over) {
                        $('#modal-info').find('#status-info').html(data.text + '<br>' + data.status + '');
                        if (profileUrl === window.location.origin + window.location.pathname) {
                            $('#modal-info').fancybox({
                                touch: false,
                                'afterClose':function () {
                                    window.location.href = profileUrl;
                            }}).trigger('click');
                        } else {
                            $('#modal-info').fancybox({
                                touch: false
                            }).trigger('click');
                        }
                    }
                },
                error   : function (error) {
                    console.log(error);
                }
            });
        };
        setInterval(statusInformer, 1000 * 15);
    }
    if ($('.js-change-lang').length) {
        $('.js-change-lang').click(function () {
            $(this).parents('.box-lang').toggleClass('active');
            $('.list-lang-wrap').slideToggle();
        });
    }
    if ($('.js-show-mob-menu').length) {
        $('.js-show-mob-menu').click(function () {
            $('.header').toggleClass('open-menu');
            $('.main-nav').slideToggle();
        });
    }
    if ($('.js-show-account-menu').length) {
        $('.js-show-account-menu').click(function () {
            $(this).next('.account-menu').slideToggle();
        });
    }
    if ($('.fancybox').length) {
        $('.fancybox').fancybox({touch: false});
    }

    /*menu btn*/
    function toggleMenu(elem) {
        $(elem).toggleClass('active');
        $(elem).next().toggleClass('opened');
        $('html').toggleClass('no-scroll');
        $('.overlay').toggle();
    }

    $('.js_menu-btn').on('click', function() {
        toggleMenu($(this))
    });

    $('.overlay').on('click', function() {
        toggleMenu('.js_menu-btn')
    });

    /* sticky-menu */
    var  menu = $(".js-fixed-header"),
        h_menu = $(".js-fixed-header").height();
    $(window).scroll(function() {
        if( $(this).scrollTop() > h_menu ) {
            menu.addClass('fixed');
        } else {
            menu.removeClass('fixed');
        }
    });
    if( $(this).scrollTop() > h_menu ) {
        menu.addClass('fixed');
    } else {
        menu.removeClass('fixed');
    }
    /* sticky-menu */
    if($('.js-scroll-top').length) {
        $(window).scroll(function () {
            if ($(this).scrollTop() > 0) {
                $('.js-scroll-top').addClass('visible');
            } else {
                $('.js-scroll-top').removeClass('visible');
            }
        });
        $('.js-scroll-top').click(function () {
            $('body,html').animate({
                scrollTop: 0
            }, 400);
            return false;
        });
    }
    if($('.js-scroll').length) {
        $('.js-scroll').click(function () {
            var target = $(this).attr('href');
            $('html, body').animate({
                scrollTop: $(target).offset().top
            }, 1000);
            return false;
        })
    }
    if ($(window).width() <= 767) {
        if($('.js-show-mob-nav').length) {
            $('.js-show-mob-nav').click(function () {
                $(this).toggleClass('active');
                $(this).parents('.footer__item').find('.footer-menu-list_hid-mob').slideToggle();
            });
        }
    }
    if ($('#modal-success').length) {
        $('#modal-success').fancybox({touch: false}).trigger('click');
    }
    if ($('#modal-error').length) {
        $('#modal-error').fancybox({touch: false}).trigger('click');
    }
    if ($('#modal-errors').length) {
        $('#modal-errors').fancybox({touch: false}).trigger('click');
    }
        $(window).keydown(function(event){
            if(event.keyCode == 13) {
                event.preventDefault();
                return false;
            }
        });


    /*Function for same height*/

    window.addEventListener('load', function () {
        heightBlock();
    });

    window.addEventListener('orientationchange', function () {
        heightBlock();
    });

    $(window).on('resize', function () {
        heightBlock();
    });

    function heightBlock() {
        $('.js_height-block').each(function (i, e) {
                var elH = e.getElementsByClassName("height");
                var maxHeight = 0;
                for (var i = 0; i < elH.length; ++i) {
                    elH[i].style.height = "";
                    if (maxHeight < elH[i].clientHeight) {
                        maxHeight = elH[i].clientHeight;
                    }
                }
                for (var i = 0; i < elH.length; ++i) {
                    elH[i].style.height = maxHeight + "px";
                }
            }
        )
    }
});



// WEBPACK FOOTER //
// ./resources/assets/frontend/js/global/global.js